(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();

    this.header = null;
    this.headerSection = null;
    this.headerBounds = { top: 0, bottom: 0 };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.preventHide = false;
    this.isScrolling = null;
    this.predictiveSearch = null;
    this._rafScroll = 0;
    this._pendingScrollTop = 0;

    this._state = 'reset';
    this.THRESHOLD_EPS = 4;

    this._started = false;
    this.onScroll = this.onScroll.bind(this);
    this._runScroll = this._runScroll.bind(this);
    this._measure = this._measure.bind(this);
    this._start = this._start.bind(this);

    this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

    this._wakeOnScroll = this._wakeOnScroll.bind(this);
    this._wakeOnPointer = this._wakeOnPointer.bind(this);
    this._wakeOnKey = this._wakeOnKey.bind(this);
    this._onResize = this._onResize.bind(this);
    this._ensureStartedOnResize = this._ensureStartedOnResize.bind(this);
    this._resizeTimer = 0;
  }

  _getDocumentTop(el) {
    let top = 0;
    let node = el;
    while (node) {
      top += node.offsetTop || 0;
      node = node.offsetParent;
    }
    return top;
  }

  connectedCallback() {
    window.addEventListener('scroll', this._wakeOnScroll, { passive: true, once: true });
    window.addEventListener('pointerdown', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('touchstart', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('keydown', this._wakeOnKey, { passive: true, once: true });
    window.addEventListener('resize', this._ensureStartedOnResize, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._wakeOnScroll);
    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);
    window.removeEventListener('resize', this._ensureStartedOnResize);
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this._onResize);

    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    if (this._rafScroll) cancelAnimationFrame(this._rafScroll);
    this._rafScroll = 0;
    if (this._resizeTimer) clearTimeout(this._resizeTimer);
    this._resizeTimer = 0;
  }

  _onResize() {
    if (this._resizeTimer) clearTimeout(this._resizeTimer);
    this._resizeTimer = setTimeout(() => {
      this._resizeTimer = 0;
      if (!this._started || !this.header) return;
      this._measure();

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const eps = this.THRESHOLD_EPS;
      if (this.currentScrollTop <= (this.headerBounds.top + eps)) {
        this._setState('reset');
      }
      this.onScroll();
    }, 120);
  }

  _wakeOnScroll() { this._start(); }
  _wakeOnPointer() { this._start(); }
  _wakeOnKey() { this._start(); }

  _ensureStartedOnResize() {
    if (!this._started) this._start();
  }

  _start() {
    if (this._started) return;

    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);

    this.header =
      document.getElementById('shopify-section-header') ||
      document.querySelector('.shopify-section-header') ||
      null;

    if (!this.header) return;

    this._started = true;

    window.removeEventListener('resize', this._ensureStartedOnResize);

    this.headerSection = this.header.querySelector('.header-section') || this.header;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    this._measure();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this._onResize, { passive: true });
    this.onScroll();
  }

  _measure() {
    if (!this.header) return;

    const outerH = Math.ceil(this.header.getBoundingClientRect().height || 0);
    const innerH = this.headerSection
      ? Math.ceil(this.headerSection.getBoundingClientRect().height || 0)
      : 0;
    const h = Math.max(outerH, innerH);
    const next = `${h}px`;
    const prev = document.documentElement.style.getPropertyValue('--header-height');
    if (prev !== next) {
      document.documentElement.style.setProperty('--header-height', next);
    }

    const top = this.headerSection ? this._getDocumentTop(this.headerSection) : 0;
    this.headerBounds = { top, bottom: top + h };
  }

  onScroll() {
    this._pendingScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (this._rafScroll) return;
    this._rafScroll = requestAnimationFrame(this._runScroll);
  }

  _runScroll() {
    this._rafScroll = 0;

    const scrollTop = this._pendingScrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) {
      this.currentScrollTop = scrollTop;
      return;
    }

    if (window.getComputedStyle(this.header).display === 'none') {
      this.currentScrollTop = scrollTop;
      return;
    }

    const layoutRect = this.headerSection?.getBoundingClientRect();
    if (!layoutRect || layoutRect.height < 1) {
      this.currentScrollTop = scrollTop;
      return;
    }

    const eps = this.THRESHOLD_EPS;
    let hb = this.headerBounds;
    if (!(hb.bottom > hb.top + eps)) {
      this._measure();
      hb = this.headerBounds;
    }
    if (!(hb.bottom > hb.top + eps)) {
      this.currentScrollTop = scrollTop;
      return;
    }

    const pastBottom = scrollTop > (hb.bottom + eps);
    const beforeTop  = scrollTop <= (hb.top + eps);

    if (!pastBottom) {
      if (beforeTop) {
        this._setState('reset');
      } else if (scrollTop < this.currentScrollTop) {
        this._setState('revealed');
      } else {
        this._setState('reset');
      }
      this.currentScrollTop = scrollTop;
      return;
    }

    if (scrollTop > this.currentScrollTop && pastBottom) {
      if (!this.preventHide) this._setState('hidden');
    } else if (scrollTop < this.currentScrollTop && pastBottom) {
      if (!this.preventReveal) {
        this._setState('revealed');
      } else {
        clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        this._setState('hidden');
      }
    } else if (beforeTop) {
      this._setState('reset');
    }

    this.currentScrollTop = scrollTop;
  }

  _setState(next) {
    if (!this.header || this._state === next) return;
    this._state = next;

    if (next === 'hidden') {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      return;
    }

    if (next === 'revealed') {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      return;
    }

    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-header"]) return;
  try {
    
  class MobileStickyHeader extends HTMLElement {
    constructor() {
      super();
      this._onLayoutResize = this._onLayoutResize.bind(this);
      this._layoutResizeTimer = 0;
    }

    connectedCallback() {
      this.header =
        document.getElementById('shopify-section-mobile-header') ||
        this.closest('.shopify-section-mobile-header');
      if (!this.header) return;
      this.headerSection = this.header.querySelector('.mobile-header');
      if (!this.headerSection) return;

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.preventHide = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this._onLayoutResize, { passive: true });

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this._onLayoutResize);
      if (this._layoutResizeTimer) clearTimeout(this._layoutResizeTimer);
      this._layoutResizeTimer = 0;
    }

    _onLayoutResize() {
      if (this._layoutResizeTimer) clearTimeout(this._layoutResizeTimer);
      this._layoutResizeTimer = setTimeout(() => {
        this._layoutResizeTimer = 0;
        if (!this.header || !this.headerSection) return;
        if (!window.matchMedia('(max-width: 920px)').matches) return;
        this.createObserver();
        this.onScrollHandler();
      }, 120);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.headerSection);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-mobile-header-hidden', 'shopify-section-mobile-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-mobile-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-mobile-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-mobile-header-hidden', 'shopify-section-mobile-header-sticky', 'animate');
    }
  }

  customElements.define('mobile-sticky-header', MobileStickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secondary-header"]) return;
  try {
    
class StickySecondaryHeader extends HTMLElement {
  constructor() {
    super();

    this.header = null;
    this.headerSection = null;
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.preventHide = false;
    this.isScrolling = null;
    this.predictiveSearch = null;
    this._rafScroll = 0;
    this._pendingScrollTop = 0;

    this._state = 'reset';
    this.headerBounds = { top: 0, bottom: 0 };
    this.THRESHOLD_EPS = 4;

    this._started = false;
    this.onScroll = this.onScroll.bind(this);
    this._runScroll = this._runScroll.bind(this);
    this._measure = this._measure.bind(this);
    this._start = this._start.bind(this);

    this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

    this._wakeOnScroll = this._wakeOnScroll.bind(this);
    this._wakeOnPointer = this._wakeOnPointer.bind(this);
    this._wakeOnKey = this._wakeOnKey.bind(this);
    this._onResize = this._onResize.bind(this);
    this._ensureStartedOnResize = this._ensureStartedOnResize.bind(this);
    this._resizeTimer = 0;
  }

  _getDocumentTop(el) {
    let top = 0;
    let node = el;
    while (node) {
      top += node.offsetTop || 0;
      node = node.offsetParent;
    }
    return top;
  }

  connectedCallback() {
    window.addEventListener('scroll', this._wakeOnScroll, { passive: true, once: true });
    window.addEventListener('pointerdown', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('touchstart', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('keydown', this._wakeOnKey, { passive: true, once: true });
    window.addEventListener('resize', this._ensureStartedOnResize, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._wakeOnScroll);
    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);
    window.removeEventListener('resize', this._ensureStartedOnResize);
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this._onResize);

    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    if (this._rafScroll) cancelAnimationFrame(this._rafScroll);
    this._rafScroll = 0;
    if (this._resizeTimer) clearTimeout(this._resizeTimer);
    this._resizeTimer = 0;
  }

  _onResize() {
    if (this._resizeTimer) clearTimeout(this._resizeTimer);
    this._resizeTimer = setTimeout(() => {
      this._resizeTimer = 0;
      if (!this._started || !this.header) return;
      this._measure();
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const eps = this.THRESHOLD_EPS;
      if (this.currentScrollTop <= (this.headerBounds.top + eps)) {
        this._setState('reset');
      }
      this.onScroll();
    }, 120);
  }

  _wakeOnScroll() { this._start(); }
  _wakeOnPointer() { this._start(); }
  _wakeOnKey() { this._start(); }

  _ensureStartedOnResize() {
    if (!this._started) this._start();
  }

  _start() {
    if (this._started) return;

    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);

    this.header = this.closest('.shopify-section-header');
    if (!this.header) return;

    this._started = true;

    window.removeEventListener('resize', this._ensureStartedOnResize);

    this.headerSection =
      this.header.querySelector('.secondary-header-section') ||
      this.header.querySelector('.header-section') ||
      this.header;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    this._measure();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this._onResize, { passive: true });
    this.onScroll();
  }

  _measure() {
    if (!this.header) return;

    const outerH = Math.ceil(this.header.getBoundingClientRect().height || 0);
    const innerH = this.headerSection
      ? Math.ceil(this.headerSection.getBoundingClientRect().height || 0)
      : 0;
    const h = Math.max(outerH, innerH);
    const next = `${h}px`;
    const primarySticky = document.querySelector('sticky-header');
    const skipGlobalHeaderHeight =
      primarySticky && this.header && !this.header.contains(primarySticky);
    if (!skipGlobalHeaderHeight) {
      const prev = document.documentElement.style.getPropertyValue('--header-height');
      if (prev !== next) {
        document.documentElement.style.setProperty('--header-height', next);
      }
    }

    const top = this.headerSection ? this._getDocumentTop(this.headerSection) : 0;
    this.headerBounds = { top, bottom: top + h };
  }

  onScroll() {
    this._pendingScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (this._rafScroll) return;
    this._rafScroll = requestAnimationFrame(this._runScroll);
  }

  _runScroll() {
    this._rafScroll = 0;

    const scrollTop = this._pendingScrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) {
      this.currentScrollTop = scrollTop;
      return;
    }

    if (window.getComputedStyle(this.header).display === 'none') {
      this.currentScrollTop = scrollTop;
      return;
    }

    const layoutRect = this.headerSection?.getBoundingClientRect();
    if (!layoutRect || layoutRect.height < 1) {
      this.currentScrollTop = scrollTop;
      return;
    }

    const eps = this.THRESHOLD_EPS;
    let hb = this.headerBounds;
    if (!(hb.bottom > hb.top + eps)) {
      this._measure();
      hb = this.headerBounds;
    }
    if (!(hb.bottom > hb.top + eps)) {
      this.currentScrollTop = scrollTop;
      return;
    }

    const pastBottom = scrollTop > (hb.bottom + eps);
    const beforeTop  = scrollTop <= (hb.top + eps);

    if (scrollTop <= (hb.bottom + eps)) {
      this._setState('reset');
      this.currentScrollTop = scrollTop;
      return;
    }

    if (scrollTop > this.currentScrollTop && pastBottom) {
      if (!this.preventHide) this._setState('hidden');
    } else if (scrollTop < this.currentScrollTop && pastBottom) {
      if (!this.preventReveal) {
        this._setState('revealed');
      } else {
        clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        this._setState('hidden');
      }
    } else if (beforeTop) {
      this._setState('reset');
    }

    this.currentScrollTop = scrollTop;
  }

  _setState(next) {
    if (!this.header || this._state === next) return;
    this._state = next;

    if (next === 'hidden') {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      return;
    }

    if (next === 'revealed') {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      return;
    }

    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
}

customElements.define('sticky-secondary-header', StickySecondaryHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vorug-pact-editorial"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = (root = document) => root.querySelectorAll('.vpact-products').forEach(track => {
    if (track.dataset.pactCarouselReady) return;
    track.dataset.pactCarouselReady = 'true';
    const cards = [...track.children];
    if (cards.length < 2) return;
    const mobile = matchMedia('(max-width: 600px)');
    const controls = document.createElement('div');
    controls.className = 'vpact-carousel-controls';
    controls.innerHTML = '<span class="label_font_uppercase">STUDIO SELECTION <span class="vpact-carousel-position" role="status" aria-live="polite" aria-atomic="true">01 / 03</span></span><div><button type="button" aria-label="Previous rug">←</button><button type="button" aria-label="Next rug">→</button></div>';
    track.after(controls);
    track.setAttribute('aria-label', 'Studio rug selection');
    let copies = [], start = 0, period = 0, timer;
    const position = controls.querySelector('.vpact-carousel-position');
    const updatePosition = () => {
      const step = cards[1].offsetLeft - cards[0].offsetLeft;
      if (!step) return;
      const index = ((Math.round((track.scrollLeft - start) / step) % cards.length) + cards.length) % cards.length;
      position.textContent = `${String(index + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
      position.setAttribute('aria-label', `Rug ${index + 1} of ${cards.length}`);
    };
    const jump = left => {
      track.style.scrollSnapType = 'none';
      track.scrollLeft = left;
      requestAnimationFrame(() => { track.style.scrollSnapType = ''; });
    };
    const measure = () => {
      if (!mobile.matches || !copies.length) return;
      const inset = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      start = cards[0].offsetLeft - inset;
      period = copies[cards.length].offsetLeft - cards[0].offsetLeft;
      jump(start); updatePosition();
    };
    const activate = () => {
      clearTimeout(timer);
      copies.forEach(card => card.remove()); copies = [];
      controls.hidden = !mobile.matches;
      if (!mobile.matches) { track.scrollLeft = 0; return; }
      const duplicate = card => {
        const clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true'); clone.inert = true;
        clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        clone.removeAttribute('id'); clone.removeAttribute('data-shopify-editor-block');
        return clone;
      };
      const before = cards.map(duplicate), after = cards.map(duplicate);
      track.prepend(...before); track.append(...after); copies = [...before, ...after];
      measure();
    };
    track.addEventListener('scroll', () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (!mobile.matches || !period) return;
        const delta = track.scrollLeft - start;
        if (delta < -1 || delta >= period - 1) jump(start + ((delta % period) + period) % period);
        updatePosition();
      }, 160);
    }, {passive: true});
    const move = direction => {
      const step = cards[1].offsetLeft - cards[0].offsetLeft;
      track.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    };
    controls.querySelectorAll('button').forEach((button, i) => button.addEventListener('click', () => move(i ? 1 : -1)));
    track.addEventListener('focusin', event => {
      if (mobile.matches && cards.some(card => card === event.target || card.contains(event.target))) {
        const card = cards.find(card => card === event.target || card.contains(event.target));
        jump(card.offsetLeft - (parseFloat(getComputedStyle(track).paddingLeft) || 0));
      }
    });
    mobile.addEventListener('change', activate);
    let width = track.clientWidth;
    new ResizeObserver(() => {
      if (width === track.clientWidth) return;
      width = track.clientWidth; measure();
    }).observe(track);
    activate();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup()); else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

(() => {
  if (window.vorugPactMotion || !Element.prototype.animate || !window.IntersectionObserver) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const ease = 'cubic-bezier(.16,1,.3,1)';
  const active = new Set();
  const jobs = new WeakMap();
  const animate = (element, frames, duration = 700, delay = 0) => {
    if (!element || reduced.matches) return;
    const animation = element.animate(frames, {duration, delay, easing: ease, fill: 'backwards'});
    active.add(animation);
    const release = () => { active.delete(animation); animation.cancel(); };
    animation.finished.then(release, () => active.delete(animation));
    return animation;
  };
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      const job = jobs.get(entry.target);
      jobs.delete(entry.target);
      if (job && !reduced.matches) job();
    });
  }, {rootMargin: '0px 0px -8% 0px', threshold: 0.08});
  const enter = (element, job) => {
    if (!element || reduced.matches) return;
    // Deep-link arrivals keep already-passed chapters settled and readable.
    if (element.getBoundingClientRect().bottom < 0) return;
    jobs.set(element, job); observer.observe(element);
  };
  const words = heading => {
    if (!heading || heading.dataset.pactWords) return heading ? [...heading.querySelectorAll('.vpact-word-inner')] : [];
    heading.dataset.pactWords = 'true';
    const text = heading.textContent;
    heading.setAttribute('aria-label', text.trim());
    const fragment = document.createDocumentFragment();
    text.split(/(\s+)/).forEach(part => {
      if (/^\s+$/.test(part)) { fragment.append(document.createTextNode(part)); return; }
      if (!part) return;
      const outer = document.createElement('span');
      outer.className = 'vpact-word'; outer.setAttribute('aria-hidden', 'true');
      const inner = document.createElement('span'); inner.className = 'vpact-word-inner'; inner.textContent = part;
      outer.append(inner); fragment.append(outer);
    });
    heading.replaceChildren(fragment);
    return [...heading.querySelectorAll('.vpact-word-inner')];
  };
  const whenImageReady = (photo, job) => {
    const image = photo?.querySelector('img');
    if (!image) return;
    const reveal = () => {
      const bounds = photo.getBoundingClientRect();
      if (bounds.bottom > 0 && bounds.top < innerHeight && !reduced.matches) job();
    };
    if (image.complete && image.naturalWidth) reveal();
    else image.addEventListener('load', reveal, {once: true});
  };
  const imageArrival = (photo, direction, duration = 800) => {
    if (!photo) return;
    const crop = direction === 'side' ? 'inset(0 100% 0 0)' : 'inset(0 0 100% 0)';
    animate(photo, [{clipPath: crop}, {clipPath: 'inset(0 0 0 0)'}], duration);
    animate(photo.querySelector('img'), [{transform: 'scale(1.035)'}, {transform: 'scale(1)'}], duration + 250);
  };
  const setup = (root = document) => {
    const sections = [...root.querySelectorAll('.vpact[data-pact-section]')];
    sections.forEach(section => {
      if (section.dataset.pactMotionReady) return;
      section.dataset.pactMotionReady = 'true';
      const kind = section.dataset.pactSection;
      if (kind === 'opening') {
        const title = words(section.querySelector('h1'));
        enter(section, () => {
          whenImageReady(section.querySelector('.vpact-photo'), () => animate(section.querySelector('.vpact-photo img'), [{transform: 'scale(1.035)'}, {transform: 'scale(1)'}], 1200));
          title.forEach((word, i) => animate(word, [{transform: 'translateY(110%)', opacity: 0}, {transform: 'translateY(0)', opacity: 1}], 700, 100 + i * 45));
          animate(section.querySelector('.content-text'), [{opacity: 0, transform: 'translateY(12px)'}, {opacity: 1, transform: 'translateY(0)'}], 650, 260);
        });
      } else if (kind === 'people' || kind === 'details') {
        const photo = section.querySelector('.vpact-photo');
        enter(photo, () => whenImageReady(photo, () => imageArrival(photo, kind === 'people' ? 'down' : 'side')));
        // The picture carries the reveal; the reading column remains still.
      } else if (kind === 'bridge') {
        enter(section, () => {
          section.querySelectorAll('h2 > span').forEach((phrase, i) => animate(phrase,
            [{transform: `translateX(${i ? 24 : -24}px)`, opacity: 0, clipPath: `inset(0 ${i ? 0 : 100}% 0 ${i ? 100 : 0}%)`},
             {transform: 'translateX(0)', opacity: 1, clipPath: 'inset(0 0 0 0)'}], 750, i * 100));
        });
      } else if (kind === 'commitments') {
        const rows = [...section.querySelectorAll('.vpact-promise')];
        enter(section.querySelector('.vpact-promises'), () => rows.forEach((row, i) => animate(row,
          [{opacity: .35, transform: 'translateY(16px)'}, {opacity: 1, transform: 'translateY(0)'}], 550, i * 70)));
        rows.forEach(row => row.addEventListener('toggle', () => {
          if (row.open) animate(row.querySelector('.vpact-promise-body'), [{opacity: .25, transform: 'translateY(8px)'}, {opacity: 1, transform: 'translateY(0)'}], 250);
        }));
      } else if (kind === 'at-home') {
        enter(section.querySelector('.vpact-photo'), () => whenImageReady(section.querySelector('.vpact-photo'), () => {
          animate(section.querySelector('.vpact-photo img'), [{transform: 'scale(1.025)', opacity: .8}, {transform: 'scale(1)', opacity: 1}], 950);
        }));
      } else if (kind === 'rugs') {
        enter(section.querySelector('.vpact-products'), () => {
          [...section.querySelectorAll('.vpact-product')].filter(card => !card.closest('[aria-hidden="true"]')).forEach((card, i) => animate(card,
            [{transform: 'translateY(24px)', opacity: .5}, {transform: 'translateY(0)', opacity: 1}], 650, Math.min(i * 80, 160)));
        });
      } else if (kind === 'conversation') {
        enter(section, () => animate(section.querySelector('.content-heading'), [{clipPath: 'inset(0 100% 0 0)'}, {clipPath: 'inset(0 0 0 0)'}], 850));
      }
    });
  };
  document.addEventListener('focusin', event => {
    active.forEach(animation => { if (animation.effect?.target?.contains(event.target)) animation.cancel(); });
  });
  const settle = () => { if (reduced.matches) active.forEach(animation => animation.cancel()); };
  reduced.addEventListener('change', settle);
  // Content is visible without JS, between animations, and when motion is reduced.
  document.addEventListener('visibilitychange', () => { if (document.hidden) active.forEach(animation => animation.finish()); });
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    active.forEach(animation => { if (event.target.contains(animation.effect?.target)) animation.cancel(); });
    event.target.querySelectorAll('.vpact, .vpact-photo, .vpact-promises, .vpact-products').forEach(element => observer.unobserve(element));
  });
  window.vorugPactMotion = {setup};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup()); else setup();
})();


  } catch(e) { console.error(e); }
})();
})();
